import ReviewHandlingSessionState from '@app/model/review/ReviewStateState';
import ReviewHandlingSessionReply from '@app/model/review/ReviewStateReply';
import ReviewHandlingSessionLogEntry from '@app/model/review/ReviewHandlingSessionLogEntry';
import _isEmpty from 'lodash/isEmpty';
import ReviewHandlingSessionLogEntryType from '@app/model/review/ReviewHandlingSessionLogEntryType';

class ReviewHandlingSession {
	id: number;
	creationDate: string;
	assignedDepartmentId: number;
	state: ReviewHandlingSessionState;
	reply: ReviewHandlingSessionReply;
	logEntries: ReviewHandlingSessionLogEntry[]

	constructor(data: Partial<ReviewHandlingSession> = {}) {
		Object.assign(this, data);
	}

	public hasEntryViewedByUserId(profileId: number) {
		return !_isEmpty(this.logEntries) && this.logEntries.some((entry) => entry.profileId === profileId && entry.type === ReviewHandlingSessionLogEntryType.VIEWED);
	}
}

export default ReviewHandlingSession;